/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { customerWalletTransactions } from '../../axios/customerWalletTransactions'
import type {
	CustomerWalletTransactionsError,
	CustomerWalletTransactionsPathParams,
	CustomerWalletTransactionsResponse,
} from '../../types/CustomerWalletTransactions'

export const customerWalletTransactionsQueryKey = (
	organisation: CustomerWalletTransactionsPathParams['organisation'],
) => [{ url: '/:organisation/wallet/transactions', params: { organisation } }] as const

export type CustomerWalletTransactionsQueryKey = ReturnType<typeof customerWalletTransactionsQueryKey>

/** @see backend/nexus/modules/Billing/Http/Controllers/CustomerWalletController.php CustomerWalletController::transactions */
export function customerWalletTransactionsQueryOptions(
	organisation: CustomerWalletTransactionsPathParams['organisation'],
	config?: AxiosRequestConfig,
) {
	return queryOptions<
		CustomerWalletTransactionsResponse,
		AxiosError<CustomerWalletTransactionsError>,
		CustomerWalletTransactionsResponse,
		CustomerWalletTransactionsQueryKey
	>({
		queryKey: customerWalletTransactionsQueryKey(organisation),
		queryFn: ({ signal }) => customerWalletTransactions(organisation, { signal, ...config }).then(res => res.data),
		enabled: !!organisation,
	})
}

/** @see backend/nexus/modules/Billing/Http/Controllers/CustomerWalletController.php CustomerWalletController::transactions */
export function useCustomerWalletTransactions<TSelectData = CustomerWalletTransactionsResponse>(
	organisation: CustomerWalletTransactionsPathParams['organisation'],
	options?:
		& Partial<
			Omit<
				UseQueryOptions<
					CustomerWalletTransactionsResponse,
					AxiosError<CustomerWalletTransactionsError>,
					TSelectData,
					CustomerWalletTransactionsQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<CustomerWalletTransactionsError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...customerWalletTransactionsQueryOptions(organisation),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/Billing/Http/Controllers/CustomerWalletController.php CustomerWalletController::transactions */
export function useCustomerWalletTransactionsSuspense<TSelectData = CustomerWalletTransactionsResponse>(
	organisation: CustomerWalletTransactionsPathParams['organisation'],
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					CustomerWalletTransactionsResponse,
					AxiosError<CustomerWalletTransactionsError>,
					TSelectData,
					CustomerWalletTransactionsQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<CustomerWalletTransactionsError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...customerWalletTransactionsQueryOptions(organisation),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
